export default __webpack_public_path__ + "b602c0d16abc824b91a87a1b159486dc.png";